import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {AppConfigurationService} from '../shared/app-configuration.service';
import {map, Observable, switchMap} from 'rxjs';
import {HorizonPage} from '@model/page';
import {YearOfStudy} from '@model/year-of-study';
import {EtablissementAvecImplantationsDto, EtablissementDto, EtablissementDtoMapper} from '@services/dto/etablissementDto';
import {AnneeEtudeDto, AnneeEtudeDtoMapper} from '@services/dto/anneeEtudeDto';
import {Establishment} from '@model/establishment';
import {Country} from '@model/country';
import {PaysDto, PaysDtoMapper} from './dto/paysDto';

@Injectable({
  providedIn: 'root'
})
export class ReferenceDataService {

  private readonly _apiUrl: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigurationService) {
    this._apiUrl = this._appConfig.getConfig().apiUrls.reference;
  }

  getYearsOfStudy(): Observable<YearOfStudy[]> {
    const params = new HttpParams()
      .set('pageSize', 1000); 
    return this._http.get<HorizonPage<AnneeEtudeDto>>(`${this._apiUrl}/anneesEtudes`, { params}).pipe(
      map((page: HorizonPage<AnneeEtudeDto>) => {
        return page?.items?.map(AnneeEtudeDtoMapper.toDomain);
      })
    );
  }

  private searchEstablishments(fasePO: number, faseEstablishment: number): Observable<HorizonPage<EtablissementDto>> {
    const params = new HttpParams()
      .set('fasePO', fasePO)
      .set('fase', faseEstablishment)
      .set('pageSize', 1000); 
    return this._http.get<HorizonPage<EtablissementDto>>(`${this._apiUrl}/etablissements`, { params });
  }

  getEstablishment(fasePO: number, faseEstablishment: number): Observable<Establishment> {
    return this.searchEstablishments(fasePO, faseEstablishment).pipe(
      map((page: HorizonPage<EtablissementDto>) => page?.items[0]?.id),
      switchMap((uuid: string) => this.getEstablishmentDetails(uuid)),
    );
  }

  private getEstablishmentDetails(uuid: string): Observable<Establishment> {
    return this._http.get<EtablissementAvecImplantationsDto>(`${this._apiUrl}/etablissements/${uuid}`).pipe(
      map((establissement: EtablissementAvecImplantationsDto) => EtablissementDtoMapper.toDomain(establissement)),
    );
  }

  getCountries(): Observable<Country[]> {
    const params = new HttpParams()
    .set('pageSize', 1000); 
    return this._http.get<HorizonPage<PaysDto>>(`${this._apiUrl}/pays`, { params }).pipe(
      map((page: HorizonPage<PaysDto>) => {
        return page?.items?.map(PaysDtoMapper.toDomain);
      })
    );
  }
}
